import { render, staticRenderFns } from "./pictogram.vue?vue&type=template&id=e644c0a6"
import script from "./pictogram.vue?vue&type=script&lang=js"
export * from "./pictogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports